import { render, staticRenderFns } from "./DebtShareForm.vue?vue&type=template&id=6137354a"
import script from "./DebtShareForm.vue?vue&type=script&lang=js"
export * from "./DebtShareForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports